<template>
<div class="kls-donate-form">
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Tickets">
                    <div class="amounts">
                        <AmountSelectorConcert21/>
                        <div class="text-center"><ErrorLabel field="amount" /></div>
                    </div>
                    
                    <FormRow class="no-attend">
                      <input type="checkbox"  id="noattend" @click="toggleNoAttend" :checked="form.applications[0].subCampaign == 'Non Attendee'"/>
                      <FormLabel for="noattend">
                        I am unable to attend, please accept this donation in support of Yachad.
                      </FormLabel>
                    </FormRow>
                    <div class="note">$100 per ticket is fair market value of the event, remaining amount is tax deductible</div>
                </FormSection>                
                <FormSection title="Contact Info">
                  <div  class="contact-info">                    
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <DonorAddress />
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow>                     
                  </div>
                </FormSection>
                <FormSection title="Payment Info" last>
                  <div class="payment-info">
                    <FormRow>
                      <PaymentType check_text="Pay by DAF"/>
                    </FormRow>
                    <FormRow inline>
                      <FormCol field="card" :showLabel="false" check_text=" "/>
                    </FormRow>
                    <FormRow v-if="form.gateway === 'check'" style="justify-content: center;">
                      <FormInput class="width-half" field="description" placeholder="Fund name"/>
                    </FormRow>
                    <FormRow style="justify-content:center">
                      <Receipt :receipts="['canadian', 'us']"/>
                    </FormRow> 
                  </div>
                </FormSection>
                <div class="flex privacy-policy">
                  <input type="checkbox"  @click="setValue('custom.privacy', $event.target.checked)" /> 
                  <FormLabel>
                    I agree to the <a target="_blank" href="https://www.yachad.org/privacy-policy/">Privacy Policy</a>
                  </FormLabel>
                  <ErrorLabel field="custom.privacy" />
                </div>
                <div class="payment-btn">
                  <PaymentButton btnText="Make contribution"/>
                </div>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import AmountSelectorConcert21 from './amount-selector-concert21.vue'

export default defineComponent({
  components: {
    AmountSelectorConcert21,
  },
  setup(props) {
    const { form, setValue } = usePaymentForm()

    return {
      form,
      setValue,
      toggleNoAttend () {
        if (form.value.applications[0].subCampaign) {
          setValue('applications.0.subCampaign', null)
        }
        else {
          setValue('applications.0.subCampaign', 'Non Attendee')
        }
      }
    }
  },
})
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  max-width: 900px;
  margin: 60px auto;
}
::v-deep h2 {
  color: #ff6000;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
}
.kls-donate-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;
  .radio-part {
    min-width: 200px;
  }
  label {
    border: 2px solid #ddd;
    background: white;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: normal;
  }
  input[type='radio']:checked + label {
    background: #141233;
    color: white;
  }
  label:hover {
    background: #f7f9fb;
  }
}
.contact-info,
.payment-info {
  max-width: 600px;
  margin: auto;
}
.payment-info ::v-deep .cc-field {
  margin: auto;
}

.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.payment-btn ::v-deep .payment {
  justify-content: center;
  .btn-flex {
    background-color:#141233;
    color: white;
    border: none;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 13px;
    padding: 12px 25px;
  }
}
.privacy-policy {
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  a {
    color: #ff6000;
  }
  ::v-deep .error-label {
    bottom: 5px;
    right: -180px;
  }
}
::v-deep .focuser {
  width: 0;
}
.amounts {
  position: relative;
  ::v-deep .error-label {
    bottom: 0;
  }
}
.note {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    color: #666;
}
.no-attend {
  justify-content: center;
  text-align: center;
  display: flex;
  margin-bottom: 10px;

  ::v-deep label {
    font-size: 16px;
    text-transform: none;
    font-weight: 400;
    margin-left: 7px;
    padding-top: 3px;
  }
}
</style>

